(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62848],{

/***/ 289924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);



const CustomLink = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].a(({ theme, disabled }) => `
  color: ${disabled ? theme.colors.textSecondary : theme.colors.link500};
  text-decoration: none;
  &:hover {
    color: ${theme.colors.link700};
  }
  ${disabled ? "pointer-events: none;" : ""}
`);
const BreadcrumbItem = ({
  name,
  link,
  disabled = false,
  isEndOfBread = false
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomLink, {
    href: link,
    disabled,
    className: "breadcrumb-item"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    color: isEndOfBread ? "#000" : void 0,
    line: 1,
    level: 1
  }, name));
};
const Label = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 17px;
`;




/***/ }),

/***/ 955006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Breadcrumbs; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BreadcrumbItem_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(289924);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(203494);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ isMobile, theme }) => `
  display: flex;
  padding: ${theme == null ? void 0 : theme.spacing.s16} 0;
  align-items: ${!isMobile ? "flex-end" : "center"};
  column-gap: ${theme == null ? void 0 : theme.spacing.s4};
  white-space: nowrap;
  overflow: hidden;
  ${!isMobile ? `.breadcrumb-item:last-child div {
            white-space: normal
        }` : `
        overflow-x: auto;
        ::-webkit-scrollbar {
          display: none;
        }
      `}
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`);
const Breadcrumbs = (_a) => {
  var _b = _a, {
    breadcrumbs = [],
    isMobile
  } = _b, rest = __objRest(_b, [
    "breadcrumbs",
    "isMobile"
  ]);
  if (!breadcrumbs.length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, rest), {
    isMobile
  }), breadcrumbs.map((item, index) => {
    const isLast = index === breadcrumbs.length - 1 || item.isLast;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      key: index
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BreadcrumbItem_es_js__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbItem */ .g, __spreadValues({
      key: index
    }, item)), !isLast && !!item.name && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RightOutlined */ .g, {
      color: "placeholder",
      size: 16,
      style: { textAlign: "right", overflow: "visible" }
    }));
  }));
};




/***/ }),

/***/ 982226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);
/* harmony import */ var _Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(208984);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${_Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BREAK_POINTS.xl */ .d.xl}) {
    width: ${(props) => props.fluid ? "100%" : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(props.maxWidth || "")};
  }
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    maxWidth,
    fluid,
    ref
  }, others), children);
});
Container.displayName = "Container";




/***/ }),

/***/ 651337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ModalFooter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`;
const ModalFooter = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};




/***/ }),

/***/ 203494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RightOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RightOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.49976 19.0001L15.4998 12.0001L8.49976 5.00012",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 862010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AK": function() { return /* binding */ getComboName; },
/* harmony export */   "B1": function() { return /* binding */ getComboImageUrl; },
/* harmony export */   "IH": function() { return /* binding */ getAppliedPromotionsByCartPromotionGroupList; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "cC": function() { return /* binding */ formatPriceFull; },
/* harmony export */   "hJ": function() { return /* binding */ getDateStringWithFormat; },
/* harmony export */   "m8": function() { return /* binding */ getPromotionStatus; },
/* harmony export */   "rb": function() { return /* binding */ PromoItemType; }
/* harmony export */ });
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891004);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(883667);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(540415);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(473776);





const CURRENCY_CONFIG = {
  VND: {
    locale: "vi-VN",
    currency: "VND"
  },
  GHS: {
    locale: "en-GH",
    currency: "GHS"
  }
};
const formatPrice = (price, numberDisplayFormat) => {
  let formattedPrice = price;
  if (price) {
    formattedPrice = price.toLocaleString("vi-VN");
    if (numberDisplayFormat) {
      const [int, dec = ""] = formattedPrice.split(",");
      const formattedInt = int.replaceAll(".", numberDisplayFormat.thousandSeparator);
      formattedPrice = dec ? `${formattedInt}${numberDisplayFormat.decimalSeparator}${dec}` : formattedInt;
    }
  }
  return formattedPrice;
};
const formatPriceFull = (price, numberDisplayFormat, currency = "VND") => {
  var _a, _b, _c;
  if (price === null || price === void 0 || price === "")
    return price;
  const value = typeof price === "string" ? Number(price) : price;
  const { locale, currency: currencyCode } = CURRENCY_CONFIG[currency];
  const parts = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    maximumFractionDigits: 0
  }).formatToParts(value);
  const integer = parts.filter((p) => p.type === "integer" || p.type === "group").map((p) => p.value).join("").replace(/\D/g, "");
  const fraction = (_a = parts.find((p) => p.type === "fraction")) == null ? void 0 : _a.value;
  let formattedPrice = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  if (fraction) {
    formattedPrice += `,${fraction}`;
  }
  const currencySymbol = (_c = (_b = parts.find((p) => p.type === "currency")) == null ? void 0 : _b.value) != null ? _c : "";
  formattedPrice = `${formattedPrice}${currencySymbol}`;
  if (numberDisplayFormat) {
    const [int, dec = ""] = formattedPrice.split(",");
    const formattedInt = int.replaceAll(".", numberDisplayFormat.thousandSeparator);
    formattedPrice = dec ? `${formattedInt}${numberDisplayFormat.decimalSeparator}${dec}` : formattedInt;
  }
  return formattedPrice;
};
const sortItems = (childItems) => {
  return childItems.sort((left, right) => left.displayPriority > right.displayPriority ? 1 : -1);
};
const getComboName = (childItems) => {
  if (childItems.length === 0)
    return "";
  const primary = sortItems(childItems)[0];
  const comboLength = childItems.length;
  return comboLength === 1 ? primary.name : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("{{PrimaryName}} v\xE0 {{var0}} s\u1EA3n ph\u1EA9m kh\xE1c", {
    PrimaryName: primary.name,
    var0: comboLength - 1
  });
};
const getComboImageUrl = (childItems) => {
  if (childItems.length === 0)
    return [];
  return sortItems(childItems).map((item) => {
    var _a, _b;
    return item.imageUrl || ((_b = (_a = item.product) == null ? void 0 : _a.productInfo) == null ? void 0 : _b.imageUrl);
  });
};
const getDateStringWithFormat = (dateString, format = "HH:mm dd/MM/yyyy") => {
  try {
    return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(dateString), format);
  } catch (e) {
    return "";
  }
};
var PromoItemType = /* @__PURE__ */ ((PromoItemType2) => {
  PromoItemType2["GIFT"] = "gift";
  PromoItemType2["DISCOUNT"] = "discount";
  PromoItemType2["VOUCHER"] = "voucher";
  return PromoItemType2;
})(PromoItemType || {});
const getAppliedPromotionsByCartPromotionGroupList = (cartPromotionGroupList) => {
  const gifts = [];
  cartPromotionGroupList.forEach((blockPromotion) => {
    blockPromotion.promotions.forEach((promotion) => {
      if (promotion.cartPromotionId !== null) {
        gifts.push({
          imageUrl: promotion.imageUrl,
          name: promotion.title
        });
      }
    });
  });
  return gifts;
};
const getPromotionStatus = (cartPromotionId, isSelectable, groupType) => {
  if (groupType) {
    if (groupType === _teko_cart_v2__WEBPACK_IMPORTED_MODULE_2__/* .PromotionGroupType.GROUP_TYPE_DEFAULT */ .VM.GROUP_TYPE_DEFAULT) {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.FIXED */ .d.FIXED;
    } else {
      if (!isSelectable) {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.DISABLED */ .d.DISABLED;
      } else if (cartPromotionId === null) {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.UNSELECTED */ .d.UNSELECTED;
      } else if (cartPromotionId !== null) {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.SELECTED */ .d.SELECTED;
      }
    }
  } else {
    if (cartPromotionId === null && isSelectable) {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.UNSELECTED */ .d.UNSELECTED;
    } else if (cartPromotionId === null && !isSelectable) {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.DISABLED */ .d.DISABLED;
    } else if (cartPromotionId !== null && isSelectable) {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.SELECTED */ .d.SELECTED;
    } else {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.FIXED */ .d.FIXED;
    }
  }
};




/***/ }),

/***/ 540415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/lang/vi.es.js
var viLang = {
	
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/lang/en.es.js
var enLang = {
	"Được phép nâng giá bán tối đa": "Max raised price allowed",
	"Giá muốn bán không được vượt quá {{var0}}": "Selling price cannot exceed {{var0}}",
	"Giá muốn bán không được nhỏ hơn giá sản phẩm": "Selling price cannot be less than supplier price",
	"Giá sản phẩm": "Supplier price",
	"Giá muốn bán": "Selling price",
	"Nhập số tiền": "Input amount",
	"Số tiền chênh:": "Gap amount:",
	"Sửa giá": "Edit price",
	"Dùng sau": "Use later",
	"Áp dụng": "Apply",
	"Bỏ chọn": "Unselect",
	"Tặng 1 Ba lô Acer": "Receive 1 Acer backpack",
	"Bạn chỉ có thể mua tối đa {{maximumValue}} sản phẩm": "You can only purchase max {{maximumValue}} products",
	"Chú ý": "Note",
	"Bạn muốn xoá sản phẩm này ra khỏi giỏ hàng?": "Are your sure to delete product from Cart?",
	"Đồng ý": "Agree",
	"Hủy bỏ": "Cancel",
	"Xóa": "Delete",
	"x{{ProductVoucherQuantity}} Voucher dùng cho đơn hàng sau": "x{{ProductVoucherQuantity}} Voucher used for next order",
	"Không bán chịu": "Not selling on credit",
	"{{PrimaryName}} và {{var0}} sản phẩm khác": "{{PrimaryName}} and {{var0}} other products",
	"Chỉ áp dụng trên một số sản phẩm": "Applicable for some specific products only",
	"Giảm": "Discount",
	"tối đa {{maxAmount}}": "max {{maxAmount}}",
	"Dành": "Applicable",
	"cho đơn hàng từ {{min}} đến {{max}}": "for the order from {{min}} to {{max}}",
	"cho đơn hàng tối thiểu {{min}}": "for the order from {{min}}",
	"cho đơn hàng dưới {{max}}": "for the order under {{max}}",
	"cho tất cả các đơn hàng": "for all orders",
	"Giảm {{percent}}% tối đa {{maxAmount}}": "{{percent}}% off up to {{maxAmount}}",
	"{{quantity}}x {{name}} Mã giảm giá cho đơn hàng sau": "{{quantity}}x {{name}} Discount code for next order",
	"Thành tiền": "Total",
	"Đơn giá": "Unit price",
	"Số lượng": "Quantity",
	"Khuyến mại hot": "Promotions hot",
	"HSD:": "Expiry date:",
	"Chương trình khuyến mại": "Promotions",
	"Sản phẩm ưu đãi": "Promotional products",
	"Tìm kiếm chương trình khuyến mại": "Search promotions",
	"Xem thêm": "Show more",
	"Rút gọn": "Collapse",
	"Tìm kiếm sản phẩm khuyến mại": "Search promotional products",
	"Không tìm thấy chương trình nào.": "No program found.",
	"Không tìm thấy sản phẩm nào.": "No product found.",
	"Lỗi": "Error"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "ui-cart";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), {
    ns: NAMESPACE,
    interpolation: { escapeValue: false }
  }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 473776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PromotionStatus; }
/* harmony export */ });
var PromotionStatus = /* @__PURE__ */ ((PromotionStatus2) => {
  PromotionStatus2[PromotionStatus2["SELECTED"] = 0] = "SELECTED";
  PromotionStatus2[PromotionStatus2["UNSELECTED"] = 1] = "UNSELECTED";
  PromotionStatus2[PromotionStatus2["DISABLED"] = 2] = "DISABLED";
  PromotionStatus2[PromotionStatus2["FIXED"] = 3] = "FIXED";
  return PromotionStatus2;
})(PromotionStatus || {});




/***/ }),

/***/ 650983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(855271);
/* harmony import */ var _SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46610);
/* harmony import */ var _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(349055);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getBackground = (props) => {
  if (props.link)
    return "transparent";
  if (props.outline)
    return props.theme.colors.white;
  return props.disabled ? `${props.theme.colors.gray400} !important` : props.variant === "primary" ? props.theme.brand.primary : props.variant === "secondary" ? props.theme.brand.secondary : props.variant === "tertiary" ? props.theme.brand.tertiary : props.variant === "normal" ? props.theme.colors.gray300 : props.variant === "danger" ? props.theme.colors.red : props.variant === "disabled" ? `${props.theme.colors.gray400} !important` : props.theme.colors.gray200;
};
const getColor = (props) => {
  var _a, _b;
  if (props.variant === "tertiary")
    return props.theme.colors.text;
  if (props.tag && !props.outline && !props.link)
    return props.theme.colors.white + "!important";
  if (props.outline || props.link) {
    return props.variant === "primary" ? (_a = props.theme.brand) == null ? void 0 : _a.primary : props.variant === "secondary" ? (_b = props.theme.brand) == null ? void 0 : _b.secondary : props.variant === "danger" ? props.theme.colors.red : props.variant === "disabled" ? `${props.theme.colors.gray600} !important` : props.theme.colors.text;
  }
  if (props.disabled)
    return `${_configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.gray600 */ .r.colors.gray600} !important`;
  return props.variant && props.variant !== "normal" && !props.link ? _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.white */ .r.colors.white : _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.gray900 */ .r.colors.gray900;
};
const StyledButton = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button */ .Z.button((props) => {
  return `
    cursor: pointer;
    border-radius: 4px;
    overflow: hidden;
    ${props.size === "lg" ? `
        line-height: 1.5;
        padding: .5rem 1rem;` : `
        line-height: 1rem;
        padding: .365rem .75rem;`}
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: ${getBackground(props)};
    border-color: ${props.outline ? getColor(props) : getBackground(props)};
    color: ${getColor(props)};
    border-width: 1px;
    border-style: solid;
    user-select: none;
    text-decoration: none;
    flex-direction: ${props.flexDirection};
    position: relative;
    ${props.block ? `width: 100%;` : ""}
    ${props.disabled && "pointer-events: none;"}
    &:focus {
      outline: 0;
    }
    `;
}, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const Spacer = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div`
  width: 0.4rem;
  height: 0.4rem;
`;
const LoadingWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div((props) => `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${getBackground(props)};
  .pulse {
    position: relative;
  left: -9999px;
  width: 4px;
  height: 4px;
  border-radius: 5px;
  background-color: ${getColor(props)};
  color: ${getColor(props)};
  box-shadow: 9999px 0 0 -5px ${getColor(props)};
  animation: dot-pulse 1.5s infinite linear;
  animation-delay: 0.25s;

  &:before,
  &:after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${getColor(props)};
    color: ${getColor(props)};
  }
  &:before {
    box-shadow: 9988px 0 0 -5px ${getColor(props)};
    animation: dot-pulse-before 1.5s infinite linear;
    animation-delay: 0s;
  }
  &:after {
    box-shadow: 10010px 0 0 -5px ${getColor(props)};
    animation: dot-pulse-after 1.5s infinite linear;
    animation-delay: 0.5s;
  }
  @keyframes dot-pulse-before {
    0% {
      box-shadow: 9988px 0 0 -5px ${getColor(props)};
    }
    30% {
      box-shadow: 9988px 0 0 2px ${getColor(props)};
    }
    60%,
    100% {
      box-shadow: 9988px 0 0 -5px ${getColor(props)};
    }
  }

  @keyframes dot-pulse {
    0% {
      box-shadow: 9999px 0 0 -5px ${getColor(props)};
    }
    30% {
      box-shadow: 9999px 0 0 2px ${getColor(props)};
    }
    60%,
    100% {
      box-shadow: 9999px 0 0 -5px ${getColor(props)};
    }
  }

  @keyframes dot-pulse-after {
    0% {
      box-shadow: 10010px 0 0 -5px ${getColor(props)};
    }
    30% {
      box-shadow: 10010px 0 0 2px ${getColor(props)};
    }
    60%,
    100% {
      box-shadow: 10010px 0 0 -5px ${getColor(props)};
    }
  }
  }
`);
const StyledLink = StyledButton.withComponent("a");
const Button = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, {
    outline,
    variant,
    children,
    block,
    tag,
    icon,
    disabled,
    flexDirection = "row",
    loading,
    onClick
  } = _a, others = __objRest(_a, [
    "outline",
    "variant",
    "children",
    "block",
    "tag",
    "icon",
    "disabled",
    "flexDirection",
    "loading",
    "onClick"
  ]);
  const ButtonTag = tag === "a" ? StyledLink : StyledButton;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonTag, __spreadValues({
    ref,
    block,
    variant,
    outline,
    flexDirection,
    disabled,
    tag,
    onClick: loading ? void 0 : onClick
  }, others), icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, __spreadValues({}, icon)), icon && children && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Spacer, {
    className: "spacer"
  }), children, loading && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadingWrapper, {
    variant,
    outline
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "pulse"
  })));
});
Button.displayName = "Button";




/***/ }),

/***/ 140598:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/tin-tuc/[slug]",
      function () {
        return __webpack_require__(14901);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 665207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ HeadSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




const HeadSection = (param)=>{
    let { title , metaTitle , description , keywords , image , canonical , prevHref , nextHref , noindex =false , links  } = param;
    const { meta  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle || title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle || title || meta.title
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description || meta.description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description || meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image || meta.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image || meta.image
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            prevHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevHref
            }),
            nextHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextHref
            }),
            links === null || links === void 0 ? void 0 : links.map((attrs)=>Object.keys(attrs).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, attrs))),
            meta.dcmaVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "dmca-site-verification",
                content: meta.dcmaVerificationContent
            }),
            meta.fbDomainVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: meta.fbDomainVerificationContent
            })
        ]
    });
};


/***/ }),

/***/ 809768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useNewsFeed; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _services_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(427342);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(106454);




const useNewsFeed = (param)=>{
    let { ssrNews , ssrTotalItems =0 , page =1 , feedId  } = param;
    const { 0: news , 1: setNews  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(ssrNews);
    const { 0: totalItems , 1: setTotalItems  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(ssrTotalItems);
    const [loading, setLoading] = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .useLoading */ .r$)("useNewsFeed");
    const { terminal  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setLoading(true);
        _services_search__WEBPACK_IMPORTED_MODULE_3__/* .searchService.getNewsFeed */ .u.getNewsFeed(terminal, feedId, page).then((param)=>{
            let { news: _news , totalItems: _total  } = param;
            setNews(_news);
            setTotalItems(_total);
        }).finally(()=>{
            setLoading(false);
        });
    }, [
        page
    ]);
    return {
        news,
        totalItems,
        loading
    };
};


/***/ }),

/***/ 827204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O$": function() { return /* binding */ stripHtmlString; }
/* harmony export */ });
/* unused harmony exports getServerSidePropsNewsListPage, getServerSidePropsNewsPage */

const getServerSidePropsNewsListPage = async (context)=>{
    const terminal = context.req.tenantEnv.terminal;
    const query = context.query;
    const { news , totalItems  } = await searchService.getNewsFeed(terminal, undefined, Number(query.page));
    if (!news) {
        return {
            notFound: true
        };
    }
    return {
        props: {
            news,
            totalItems
        }
    };
};
const getServerSidePropsNewsPage = async (context)=>{
    var ref;
    const terminalCode = context.req.tenantEnv.terminal;
    const newsFeed = await searchService.getNewsFeed(terminalCode, context.query.slug);
    if (newsFeed.totalItems === 0) {
        return {
            notFound: true
        };
    }
    return {
        props: {
            news: ((ref = newsFeed.news) === null || ref === void 0 ? void 0 : ref[0]) || {}
        }
    };
};
const stripHtmlString = (html)=>html.replace(/(<([^>]+)>)/gi, "");


/***/ }),

/***/ 14901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ tin_tuc_slug_; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/helpers/index.es.js
var index_es = __webpack_require__(862010);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_es = __webpack_require__(650983);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/SvgIcon.es.js
var SvgIcon_es = __webpack_require__(46610);
// EXTERNAL MODULE: ../../.yarn/cache/react-pageflip-npm-2.0.3-6c29560540-6547364773.zip/node_modules/react-pageflip/build/index.es.js
var build_index_es = __webpack_require__(447670);
;// CONCATENATED MODULE: ./components/desktop/pages/NewsMagazine.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  min-width: 44px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




const StyleButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)((param)=>{
    let { theme  } = param;
    return "\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n\n  min-width: 36px;\n  height: 36px;\n  text-align: center;\n  box-shadow: none;\n  border-color: #ced4da;\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary, ";\n  font-size: 12px;\n  background-color: #fff;\n  padding: 8px;\n  margin: 5px;\n  &:hover {\n    background-color: #f4f4f4;\n  }\n");
});
const MagazineWrapper = styled_es/* styled.div */.z.div(_templateObject());
const ButtonWrapper = styled_es/* styled.div */.z.div(_templateObject1());
const NewsMagazine = (param)=>{
    let { images  } = param;
    // @ts-ignore
    // This lib doesn't export type :(
    let magazine;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MagazineWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleButton, {
                    onClick: ()=>{
                        // @ts-ignore
                        magazine.pageFlip().flipPrev();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_es/* SvgIcon */.l, {
                        name: "chevron-back",
                        size: 12,
                        color: "red"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(build_index_es["default"], {
                width: 600,
                height: 900,
                size: "stretch",
                ref: (ele)=>magazine = ele,
                children: images.map((image, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "imageWrapper",
                        dangerouslySetInnerHTML: {
                            __html: image
                        }
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleButton, {
                    onClick: ()=>{
                        // @ts-ignore
                        magazine.pageFlip().flipNext();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_es/* SvgIcon */.l, {
                        name: "chevron-forward",
                        size: 12,
                        color: "red"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/HeadSection.tsx
var HeadSection = __webpack_require__(665207);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./modules/news/utils/index.ts
var utils = __webpack_require__(827204);
// EXTERNAL MODULE: ./hooks/news.ts
var hooks_news = __webpack_require__(809768);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Breadcrumbs/Breadcrumbs.es.js
var Breadcrumbs_es = __webpack_require__(955006);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalHeader.es.js
var ModalHeader_es = __webpack_require__(891256);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(309110);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalFooter.es.js
var ModalFooter_es = __webpack_require__(651337);
;// CONCATENATED MODULE: ./modules/news/desktop/NewsFeedDetail.tsx
function NewsFeedDetail_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function NewsFeedDetail_templateObject() {
    const data = NewsFeedDetail_taggedTemplateLiteral([
        "\n  min-height: 70vh;\n"
    ]);
    NewsFeedDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewsFeedDetail_templateObject1() {
    const data = NewsFeedDetail_taggedTemplateLiteral([
        "\n  background-color: #ffffff;\n  border-radius: 4px;\n  padding: 1rem;\n"
    ]);
    NewsFeedDetail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = NewsFeedDetail_taggedTemplateLiteral([
        "\n  font-size: 1.5rem;\n  line-height: 30px;\n  margin-bottom: 10px;\n  font-weight: 400;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = NewsFeedDetail_taggedTemplateLiteral([
        "\n  font-size: 0.85625rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = NewsFeedDetail_taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  img {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = NewsFeedDetail_taggedTemplateLiteral([
        "\n  height: 36px;\n  padding: 0 20px;\n  min-width: 100px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}











const StyledContainer = (0,emotion_styled_browser_esm["default"])(Container_es/* Container */.W)(NewsFeedDetail_templateObject());
const NewsWrapper = emotion_styled_browser_esm["default"].div(NewsFeedDetail_templateObject1());
const NewsTitle = emotion_styled_browser_esm["default"].h1(_templateObject2());
const NewsDate = emotion_styled_browser_esm["default"].div(_templateObject3());
const NewsContent = emotion_styled_browser_esm["default"].div(_templateObject4());
const StyledButton = (0,emotion_styled_browser_esm["default"])(Button_Button_es/* Button */.z)(_templateObject5());
function NewsFeedDetail(param) {
    let { news: ssrNews  } = param;
    var ref;
    const { query  } = (0,router.useRouter)();
    const { news: newsList  } = (0,hooks_news/* useNewsFeed */.j)({
        ssrNews: [
            ssrNews
        ],
        feedId: String(query.slug)
    });
    const news = newsList === null || newsList === void 0 ? void 0 : newsList[0];
    const images = news === null || news === void 0 ? void 0 : (ref = news.content) === null || ref === void 0 ? void 0 : ref.match(/<figure class="image">.*?<\/figure>/g);
    const { 0: error , 1: setError  } = (0,react.useState)(true);
    const { baseDomain , canonicalDomain  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    if (!news) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadSection/* HeadSection */.I, {
                canonical: "".concat(canonicalDomain || baseDomain, "/tin-tuc/").concat(news.urlKey),
                title: news.metaTitle || news.name,
                image: news === null || news === void 0 ? void 0 : news.imageUrl,
                description: news.metaDescription || (0,utils/* stripHtmlString */.O$)(news.content || "").substr(0, 155)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                marginTop: "s16",
                marginBottom: "s16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_es/* Breadcrumbs */.O, {
                        breadcrumbs: [
                            {
                                name: (0,i18n.t)("Trang chủ"),
                                link: "/"
                            },
                            {
                                link: "/tin-tuc",
                                name: (0,i18n.t)("Tin tức")
                            },
                            {
                                disabled: true,
                                link: "#",
                                name: (news === null || news === void 0 ? void 0 : news.name) || ""
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsTitle, {
                                children: news.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsDate, {
                                children: (0,index_es/* getDateStringWithFormat */.hJ)((news === null || news === void 0 ? void 0 : news.updateAt) || "")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsContent, {
                                children: news.isMagazine && images ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsMagazine, {
                                    images: images
                                }) : news.isMagazine && !images ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_es/* Modal */.u, {
                                    width: "400px",
                                    visible: error,
                                    showCloseIcon: false,
                                    footer: false,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeader_es/* ModalHeader */.x, {
                                            children: (0,i18n.t)("C\xf3 lỗi xảy ra")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody_es/* ModalBody */.f, {
                                            children: (0,i18n.t)("B\xe0i viết kh\xf4ng đ\xfang định dạng magazine.")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFooter_es/* ModalFooter */.m, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                                variant: "primary",
                                                onClick: ()=>{
                                                    setError(false);
                                                },
                                                children: (0,i18n.t)("Đ\xf3ng")
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "contentWrapper",
                                    dangerouslySetInnerHTML: {
                                        __html: news.content || ""
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./tenants/_template/desktop/tin-tuc/[slug].tsx


/* harmony default export */ var _slug_ = (NewsFeedDetail);
const getServerSideProps = (/* unused pure expression or super */ null && (getServerSidePropsNewsPage));

;// CONCATENATED MODULE: ./pages/default/desktop/tin-tuc/[slug].tsx
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ var tin_tuc_slug_ = (_slug_);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [47670,93712,49774,92888,40179], function() { return __webpack_exec__(140598); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);